// extracted by css-extract-rspack-plugin
export default {"wrap":"_cf3ff079","circleFrosted":"_d2ebe9c2","iconWrap":"_b41a2192","icon":"_c6afc4e6","folderButton":"_59f453cd","heartButton":"_1858011"};